import {Component, OnInit} from '@angular/core';
import {InsititutionsService} from './insititutions.service';
import {Insititutions} from './institutions.model';
import {LibraryList} from '../search/object-detail/bottom-list/library-list/library-list.model';
import {Library} from '../search/object-detail/bottom-list/library-list/library.model';
import {BingMapService} from '../bing-maps/service/bing-map.service';
import {BingMapMarker} from '../bing-maps/bing-map-marker';
import {uniq, map, flatMap} from 'lodash';
import {County} from './institutions.enum';
import {FormControl, FormGroup} from '@angular/forms';
import {SortOrderEnum} from '../search/search-list/results/pagination/sort-list/sort-list.model';
import {TranslateService} from '../shared/translate.service';
import {OrderPipe} from 'ngx-order-pipe';

@Component({
  selector: 'app-institutions',
  templateUrl: './institutions.component.html',
  styleUrls: ['./institutions.component.scss']
})

export class InstitutionsComponent implements OnInit {
  public libs: LibraryList;
  public itemCount: number;
  public libraryList: LibraryList;
  public libraryMarkers: BingMapMarker[] = [];
  public libsCounty: string[] = County;
  public mapCitiesNames: string[];
  public sortFields = ['asc', 'desc'];
  public filters;
  public form: FormGroup;
  public selectedField: FormControl = new FormControl();

  constructor(private _institutionsService: InsititutionsService, public mapsService: BingMapService, private translator: TranslateService, private orderPipe: OrderPipe) {
  }

  ngOnInit(): void {
  this.selectedField.setValue('asc');
  }

  searchLibs(form: FormGroup): void {
    this.form = form;
    this.filters = {
      institutionName: null,
      type: null,
      city: null,
      region: null,
      sort: null,
    };
    this.filters.institutionName = form ? form.value.institutionName : null;
    this.filters.type = form ? form.value.type : null;
    this.filters.city = form ? form.value.city : null;
    this.filters.region = form ? form.value.region : null;
    this.filters.sort = this.selectedField.value || null;
  }

  setItemCount(value: number) {
    this.itemCount = value;
  }

  private initLibraryData(): void {
    this.libraryList = this.libs;
    this.mapsService.clearPushpins();
    if (this.libraryList && this.libraryList.libraries) {
      const libraryMarkers = [];
      let index = 0;
      this.libraryList.libraries.forEach((lib: Library) => {
        // lib.toBindMapMarkerSimple = this.toBindMapMarkerSimple(lib.lat, lib.lon, lib.online);
        if (lib.lat && lib.lat !== null && lib.lon && lib.lon !== null) {
          const tempIndex = !lib.online ? ++index : -1;
          libraryMarkers.push(this.toBingMapMarker('' + tempIndex, lib));
        }
      });
      this.libraryMarkers = libraryMarkers;
    }
  }

  public toBingMapMarker(index: string, lib: Library): BingMapMarker {
    return new BingMapMarker(
      lib.lat,
      lib.lon,
      lib.online,
      index,
      lib.name,
      '<span style="display: table-row">' + lib.address + '</span></br>',
      lib.url);
  }

  public toBindMapMarkerSimple(lat, lon, online) {
     return new BingMapMarker(lat, lon, online);
  }

  public onSelect(event){
    this.searchLibs(this.form);
  }

  getOrderTranslate(sortOrder: string): string {
    return this.translator.translate(sortOrder === 'desc' ? 'Institutions.filter.desc' : 'Institutions.filter.asc');
  }
}
